<template>
    <div class="main">

        <el-row class="rowbutton" :gutter="20">
            <el-col :span="4">
                <el-input size='mini'
                @keyup.enter.native="handlseach"
                 v-model="query.site_id" placeholder="输入关键字"></el-input>
            </el-col>

            <el-col :span="1.5">
               
                   <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single" @click="handlseach">查询</el-button>
            </el-col>
            
            <el-col :span="1.5">
              <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="warning" plain  size="mini"  @click="handlebai" >IP白名单</el-button>
            </el-col>
         <el-col :span="1.5">
                <el-button type="warning" plain  size="mini"  @click="handlehei" >IP黑名单</el-button>
            </el-col>
            <el-col :span="1.5">
                <el-button type="danger" icon="el-icon-delete" plain  size="mini" :disabled="aaa"  @click="adSiteDeletemap1" >删除</el-button>
            </el-col>
            <span v-if="role" style="color:red;font-size:16px">客服微信nodetcp</span>

        </el-row>
        <el-table :data="tableData" @selection-change="handleSelectionChange"  v-loading="loading" style="width: 100%">
            <el-table-column
      type="selection"
      width="55">
    </el-table-column>
            <el-table-column prop="site_id" align='center' label="ID" width="60">
            </el-table-column>
            
            <!-- <el-table-column label="屏蔽vpn" align='center' width="120">
                <template slot-scope="scope">
                    {{scope.row.delivery?'是':'否'}}
                </template>
            </el-table-column> -->
            <el-table-column prop="name" align='center' label="策略名称" >
            </el-table-column>
            <el-table-column prop="region" align='center' label="国家" >
            </el-table-column>
            <el-table-column prop="type" align='center' label="可见设备">
            </el-table-column>
            <el-table-column prop="youdao" align='center' label="安全页">
            </el-table-column>
            <el-table-column prop="youdaolianjie" align='center' label="安全页链接">
            </el-table-column>
            <el-table-column prop="anquan" align='center' label="落地页">
            </el-table-column>
            <el-table-column prop="anquanlianjie" align='center' label="落地页链接">
            </el-table-column>
            <el-table-column align='center' width="300" label="操作">
                <template slot-scope="scope">
                    <el-button type="success" plain size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="primary" plain size="mini" @click="copy1(scope.row)">复制</el-button>
                    <el-button type="danger"  plain size="mini" style="margin-right:10px" @click="handleDel(scope.row)">删除</el-button>
                    <!-- <el-button type="info" plain  size="mini"  @click="download(scope.row)" >下载</el-button> -->
                    <el-popover placement="top" width="80" trigger="hover">
                        <div >
                            <el-popover
                           
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="建议使用php版本。php版本：将下载的压缩包上传到网站子目录解压即可。js版本：复制代码粘贴到第三方网站对应位置">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明（必看）</el-button>
  </el-popover>
                            <el-button type="primary"  plain size="mini" @click="download(scope.row)">php</el-button>
                            <el-button type="primary"  :disabled='scope.row.anquan=="inner html"' plain size="mini" @click="jsdownload(scope.row)">js</el-button>
                             
                        </div>
                        <el-button size="mini" type="info" slot="reference">下载</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
        <!-- <el-pagination
            :page-size="query.limit"
              @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="total">
        </el-pagination> -->
        <el-dialog   :before-close="guan" :close-on-click-modal = "false"  :visible.sync="openpdf" width="1000px" append-to-body>
            <el-form :model="form" :rules="formRules" label-width="80px" ref="dataForm">
                <!-- <el-form-item label="广告域名">
    <el-input v-model="form.name"></el-input>
  </el-form-item> -->
   <el-row>
                    <el-col :span="12">
                        <el-form-item label="安全模式" prop="delivery">
                    <el-switch v-model="form.moshi"></el-switch>
                     <el-popover
                            class="shuo"
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="审核前建议打开安全模式，通过后再关掉">
    <el-button style="color: rgb(230 60 60);" type="text" slot="reference">说明（必看）</el-button>
  </el-popover>
                </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="策略名称" prop="name">
                        <el-input
                        v-model="form.name">
                            </el-input>
                        </el-form-item>
                    </el-col>
   </el-row>
                
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="屏蔽爬虫">
                            <el-radio-group v-model="form.resource">
                                <el-radio label="是"></el-radio>
                                <el-radio label="否"></el-radio>
                            </el-radio-group>
                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="选择国家" prop="region">
                           
                            <el-select  v-model="form.region" multiple filterable placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <el-popover
                            class="shuo"
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="只有选中的国家才能看到落地页，其他国家的流量会被屏蔽掉">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明</el-button>
  </el-popover>
                        </el-form-item>
                    </el-col>
                    
                    
                </el-row>

                <el-row>
                    
                    <el-col :span="12">
                        <!-- <el-form-item label="屏蔽VPN" prop="delivery">
                            <el-switch v-model="form.delivery"></el-switch>
                        </el-form-item> -->
                        <el-form-item  label="屏蔽无头浏览器" label-width="115px">
                          <el-switch v-model="form.heard"></el-switch>
                              <el-popover
                            class="shuo"
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="屏蔽机器人，建议打开">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明（必看）</el-button>
  </el-popover>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="屏蔽浏览器语言" label-width="120px">
                            <el-select v-model="form.language" multiple filterable placeholder="请选择">
                                <el-option v-for="item in optionslanguage" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row>
                   <el-col :span="12">
                        <el-form-item label="可见设备" prop="type">
                            <el-checkbox-group v-model="form.type">
                                <el-checkbox label="手机" name="type"></el-checkbox>
                                <el-checkbox label="电脑" name="type"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="屏蔽操作系统" label-width="105px">
                            <el-select v-model="form.opersystem" multiple filterable placeholder="请选择">
                                <el-option v-for="item in optionopersystem" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row>
                   <el-col :span="12">
                        <el-form-item label="最大访问次数" prop="frequency" label-width="105px">
                            <el-input
                                 v-model.number='form.frequency'
                                 type='number'
                                >
                            </el-input>
                            <el-popover
                            class="shuo"
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="每分钟用户最大访问次数，例如填2，用户在一分钟内前两次访问是落地页。第三次进入是安全页">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明</el-button>
  </el-popover>
                           
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  label="屏蔽不常见ISP" label-width="110px">
                          <el-switch v-model="form.isp"></el-switch>
                        </el-form-item>

                    </el-col>
                </el-row>
                 <el-row>
                   <el-col :span="12">
                        <el-form-item label="屏幕分辨率" prop="sceen" label-width="95px">
                           <el-switch v-model="form.sceen"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        

                    </el-col>
                </el-row>
                  <el-row v-if="form.sceen">
                   <el-col :span="6">
                        <el-form-item label="宽度>" prop="widths">
                            <el-input v-model.number='form.widths' type='number' >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item  label="高度>" prop="heights">
                         <el-input v-model.number='form.heights' type='number' >
                         </el-input>
                        </el-form-item>
             
                    </el-col>
                </el-row>
                 <el-row>
                    <el-col :span="12">
                        <el-form-item label="流量来源" label-width="80px">
                            <el-select v-model="form.refefef" multiple filterable placeholder="请选择">
                                <el-option v-for="item in refefefoptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <el-radio-group v-model="form.refefef">
                                <el-radio label="是"></el-radio>
                                <el-radio label="否"></el-radio>
                            </el-radio-group> -->
                            <el-popover
                            class="shuo"
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="屏蔽流量来源。例如选择facebook，那所以非facebook平台来源流量将被过滤。若留空，则不会进行来源过滤">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明</el-button>
  </el-popover>
                        </el-form-item>

                    </el-col>
                 </el-row>
                <el-row class="anquan">
                    <el-col :span="12">
                        <p>安全页</p>
                        <el-form-item label="展示方式" prop="youdao">
                            <el-select v-model="form.youdao" placeholder="请选择">
                                <el-option v-for="item in youdaooptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                    

                        <el-form-item label="链接" prop="youdaolianjie" 
                        v-if="form.youdao=='301'||form.youdao=='采集'||form.youdao=='ifame'||form.youdao=='proxy'">
                            <el-input v-model="form.youdaolianjie"></el-input>
                        </el-form-item>

                        <!-- <el-form-item label="类型" prop="sitetype" 
                        v-if="form.youdao=='超简页'">
                            <el-select v-model="form.sitetype" placeholder="请选择">
                                <el-option v-for="item in sitetypeoptions" :key="item.name" :label="item.znname" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        
                        <!-- <el-form-item label="类型" prop="complete" 
                        v-if="form.youdao=='整站'">
                            <el-select v-model="form.complete" placeholder="请选择">
                                <el-option v-for="item in completeoptions" :key="item.name" :label="item.znname" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item label="商品类型" prop="commerce" 
                        v-if="form.sitetype=='commerce'&&form.youdao=='超简页'">
                            <el-select v-model="form.commerce" placeholder="请选择">
                                <el-option v-for="item in commerceoptions" :key="item.name" :label="item.znname" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        
                         <!-- <el-form-item label="类型" prop="sitetype" 
                        v-if="form.youdao=='301'||form.youdao=='采集'||form.youdao=='ifame'">
                            <el-input v-model="form.youdaolianjie"></el-input>
                        </el-form-item> -->
                        <span style="color:#52bb4c;margin-right:20px" v-if="form.youdao=='inner html'">inner html方式只适用于php集成方式，js不适用</span>

                        <el-popover
                        v-if="form.youdao=='proxy'"
  placement="top-start"
  width="300"
   trigger="hover">
  <div> 

当选择反向代理时需配置伪静态，nginx伪静态规则如下：<br> <br> 
       set $sub_uri $uri;<br> 
    if ($sub_uri ~* "^/([^/]+)(/.+)?") {<br> 
    set $sub_dir $1;<br> 
  }<br> 
if ( !-e $request_filename) {<br> 
 rewrite ^/(.*)$ /$sub_dir/index.php?$1 last;<br> 

}<br> 
  </div>
 <el-button style="color: red;" type="text" slot="reference">说明（必看）</el-button>
</el-popover>


                             <el-popover
                            v-if="form.youdao=='inner html'"
      class="shuo1"
    placement="top-start"
    style="position: static;"
    title=""
    width="200"
    trigger="hover"
    content="当选择inner html的展示方式时，你需要将安全页的网页文件资源放在和cloak代码同一个子目录下，并且重命名为safety.php">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明（必看）</el-button>
  </el-popover>
                         <span style="color:red;margin-left: 80px;" v-if="form.youdao=='301'">慎用</span>
                       
                         <!-- <span style="color:red;margin-left: 80px;" >如对安全页没有特殊要求，建议使用超简页或者全站方式</span> -->
                       
                    </el-col>
                    <el-col :span="12">
                        <p>落地页</p>
                        <el-form-item label="展示方式" prop="anquan">
                            <el-select v-model="form.anquan" placeholder="请选择">
                                <el-option v-for="item in anquanoptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="链接" prop="anquanlianjie"
                        v-if="form.anquan=='301'||form.anquan=='ifame'">
                            <el-input v-model="form.anquanlianjie"></el-input>
                           
                        </el-form-item>
                        <span style="color:#52bb4c" v-if="form.anquan=='inner html'">inner html方式只适用于php集成方式，js不适用</span>
                        <span style="color:#52bb4c" v-if="form.anquan=='原站点'">原站点方式只适用于js集成方式，php不适用</span>
                         <el-popover
                            v-if="form.anquan=='inner html'"
                            class="shuo1"
    placement="top-start"
    title=""
    width="200"
    trigger="hover"
    content="当选择inner html的展示方式时，你需要将落地的网页文件资源放在和cloak代码同一个子目录下，并且重命名为data.php">
    <el-button style="color: #e6a23c;" type="text" slot="reference">说明（必看）</el-button>
  </el-popover>
                    </el-col>
                </el-row>
                <!-- <el-form-item label="特殊资源">
    <el-radio-group v-model="form.resource">
      <el-radio label="线上品牌商赞助"></el-radio>
      <el-radio label="线下场地免费"></el-radio>
    </el-radio-group>
  </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="formSubmit">立即创建</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="openjs" width="450px" append-to-body>
            <el-input v-model="copyjs"></el-input>
            <el-button type="primary" plain size="mini" class="copy-code-button" :data-clipboard-text="copyjs" style="margin-top:10px;display:table;
      margin:10px auto;" @click="copy">
                一键复制
            </el-button>

        </el-dialog>

         <el-dialog :visible.sync="openbai" width="400px" title="ip白名单" append-to-body>
                  <el-input
                    type="textarea"
                    :rows="7"
                    placeholder="每行一个ip地址"
                    v-model="textarea">
                  </el-input>
             <el-button style="display:table;
      margin:15px auto;" type="primary" size="mini" @click="formbai">确定</el-button>     
        </el-dialog>

           <el-dialog :visible.sync="openhei" width="400px" title="ip黑名单" append-to-body>
                  <el-input
                    type="textarea"
                    :rows="7"
                    placeholder="每行一个ip地址"
                    v-model="textarea1">
                  </el-input>
             <el-button style="display:table;
      margin:15px auto;" type="primary" size="mini" @click="formhei">确定</el-button>     
        </el-dialog>

    </div>

</template>


  <script>

import Clipboard from 'clipboard'
import {
    adSiteList,
    adSiteAdList,
    adSiteSave,
    editsave,
    adSiteDelete,
    creatjs,
    deletetem,
    listbai,
    listhei,
    addbai,
    addhei,
    getCurl,
    geteasy,
    downloadphp,
    newdownloadphp,
    adSiteDeletemap,
    
} from "../../api/ad/adSite";
export default {
    data() {
        return {
            openhei:false,
            timer:null,
            aaa:true,
            multipleSelection:[],
            sitetypeoptions:[],
            role:false,
            textarea:"",
            textarea1:'' ,
            openbai:false,
            copyjs: '',
            openjs: false,
            query: {
                site_id: '',
                title: "",
                page: 1,
                limit: 15
            },
            loading: true,
            formRules: {
                region: [
                    { required: true, message: '请选择国家', trigger: 'blur' },
                ],
                type: [
                    { required: true, message: '请选择可见设备', trigger: 'blur' },
                ],
                youdao: [
                    { required: true, message: '请选择跳转方式', trigger: 'blur' },
                ],
                youdaolianjie: [
                    { required: true, message: '请填写链接', trigger: 'blur' },
                ],
                anquan: [
                    { required: true, message: '请选择跳转方式', trigger: 'blur' },
                ],
                anquanlianjie: [
                    { required: true, message: '请填写链接', trigger: 'blur' },
                ],
                widths: [
                    { required: true, message: '请填写宽度', trigger: 'blur' },
                ],
                heights: [
                    { required: true, message: '请填写高度', trigger: 'blur' },
                ]
            },
            anquanoptions: [{
                value: '301',
                label: '301'
            }, {
                value: 'ifame',
                label: 'ifame'
            },
            { 
                value: 'inner html',
                label: 'inner html'               
            },
            { 
                value: '原站点',
                label: '原站点'               
            }
           ],
           refefefoptions:[
             {
                value: 'facebook',
                label: 'facebook'
            },
            { 
                value: 'google',
                label: 'google'               
            },
            { 
                value: 'tiktok',
                label: 'tiktok'               
            }
           ],
            youdaooptions: [
                {
                     value: 'proxy',
                label: '反向代理'
                    
                },
            {
                value: '全站',
                label: '全站'
            },
                {
                value: '超简页',
                label: '超简页'
            },
            {
                value: '301',
                label: '301'
            }, {
                value: '采集',
                label: '采集'
            }, {
                value: 'ifame',
                label: 'ifame'
            }, {
                value: '404',
                label: '404'
            }, 
            
            { 
                value: 'inner html',
                label: 'inner html'               
            },
            { 
                value: '原站点',
                label: '原站点'               
            }],
            optionopersystem:[
             {
                value: 'windows',
                label: 'windows' 
             },
             {
                value: 'mac',
                label: 'mac' 
             },
             {
                value: 'ios',
                label: 'ios' 
             },
             {
                value: 'android',
                label: 'android' 
             },
             {
                value: 'unix',
                label: 'unix' 
             },
             {
                value: 'linux',
                label: 'linux' 
             },
             {
                value: '其他',
                label: '其他' 
             },
             
            ],
            form: {
                name:'',
                site_id: '',
                region: [],
                frequency:'',
                opersystem:[],
                language: [],
                delivery: false,
                moshi: false,
                heights:'',
                widths:'',
                heard:true,
                sceen:false,
                isp:false,
                type: [],
                youdao: '',
                youdaolianjie: '',
                anquan: '',
                resource: '是',
                refefef:'否',
                anquanlianjie: '',
                sitetype:'welfare',
                // complete:'news',
                commerce:'clothing'
            },
            single: false,
            multiplea: false,
            openpdf: false,
            optionslanguage: [
                {
                    value: 'zh',
                    label: '中文'
                },
                {
                    value: 'en',
                    label: '英文'
                },
                {
                    value: 'fr',
                    label: '法语'
                },
                {
                    value: 'de',
                    label: '德语'
                },
                {
                    value: 'jp',
                    label: '日语'
                },
                {
                    value: 'it',
                    label: '意大利语'
                },
                {
                    value: 'ko',
                    label: '韩语'
                },
                {
                    value: 'ms',
                    label: '马来语'
                },
                {
                    value: 'pt',
                    label: '葡萄牙语'
                },
                {
                    value: 'es',
                    label: '西班牙语'
                },
                {
                    value: 'tr',
                    label: '土耳其语'
                },
                {
                    value: 'fa',
                    label: '波斯语'
                },
                {
                    value: 'ar',
                    label: '阿拉伯语'
                },

            ],
            options: [{
               value:'全球',
    label:'全球'
            },
{
    value:'中国',
    label:'中国'
    },
{value:'蒙古',label:'蒙古'},
{value:'朝鲜',label:'朝鲜'},
{value:'韩国',label:'韩国'},
{value:'日本',label:'日本'},
{value:'缅甸',label:'缅甸'},
{
    value:'台湾',
    label:'中国台湾'
    },
    {
    value:'香港',
    label:'中国香港'
    },
    {
    value:'澳门',
    label:'中国澳门'
    },
{value:'泰国',label:'泰国'},
{value:'老挝',label:'老挝'},
{value:'柬埔寨',label:'柬埔寨'},
{value:'越南',label:'越南'},
{value:'菲律宾',label:'菲律宾'},
{value:'马来西亚',label:'马来西亚'},
{value:'文莱',label:'文莱'},
{value:'新加坡',label:'新加坡'},
{value:'印度尼西亚',label:'印度尼西亚'},
{value:'东帝汶',label:'东帝汶'},
{value:'巴基斯坦',label:'巴基斯坦'},
{value:'印度',label:'印度'},
{value:'尼泊尔',label:'尼泊尔'},
{value:'不丹',label:'不丹'},
{value:'孟加拉国',label:'孟加拉国'},
{value:'马尔代夫',label:'马尔代夫'},
{value:'斯里兰卡',label:'斯里兰卡'},
{value:'哈萨克斯坦',label:'哈萨克斯坦'},
{value:'乌兹别克斯坦',label:'乌兹别克斯坦'},
{value:'吉尔吉斯斯坦',label:'吉尔吉斯斯坦'},
{value:'土库曼斯坦',label:'土库曼斯坦'},
{value:'塔吉克斯坦',label:'塔吉克斯坦'},
{value:'土耳其',label:'土耳其'},
{value:'格鲁吉亚',label:'格鲁吉亚'},
{value:'亚美尼亚',label:'亚美尼亚'},
{value:'阿塞拜疆',label:'阿塞拜疆'},
{value:'伊朗',label:'伊朗'},
{value:'阿富汗',label:'阿富汗'},
{value:'黎巴嫩',label:'黎巴嫩'},
{value:'以色列',label:'以色列'},
{value:'巴勒斯坦',label:'巴勒斯坦'},
{value:'约旦',label:'约旦'},
{value:'叙利亚',label:'叙利亚'},
{value:'伊拉克',label:'伊拉克'},
{value:'沙特阿拉伯',label:'沙特阿拉伯'},
{value:'科威特',label:'科威特'},
{value:'巴林',label:'巴林'},
{value:'卡塔尔',label:'卡塔尔'},
{value:'阿联酋',label:'阿拉伯联合酋长国'},
{value:'也门',label:'也门'},
{value:'阿曼',label:'阿曼'},
{value:'冰岛',label:'冰岛'},
{value:'丹麦',label:'丹麦'},
{value:'挪威',label:'挪威'},
{value:'瑞典',label:'瑞典'},
{value:'芬兰',label:'芬兰'},
{value:'爱尔兰',label:'爱尔兰'},
{value:'英国',label:'英国'},
{value:'荷兰',label:'荷兰'},
{value:'比利时',label:'比利时'},
{value:'卢森堡',label:'卢森堡'},
{value:'法国',label:'法国'},
{value:'摩纳哥',label:'摩纳哥'},
{value:'德国',label:'德国'},
{value:'瑞士',label:'瑞士'},
{value:'列支敦士登',label:'列支敦士登'},
{value:'奥地利',label:'奥地利'},
{value:'波兰',label:'波兰'},
{value:'捷克',label:'捷克'},
{value:'斯洛伐克',label:'斯洛伐克'},
{value:'匈牙利',label:'匈牙利'},
{value:'爱沙尼亚',label:'爱沙尼亚'},
{value:'拉脱维亚',label:'拉脱维亚'},
{value:'立陶宛',label:'立陶宛'},
{value:'白俄罗斯',label:'白俄罗斯'},
{value:'乌克兰',label:'乌克兰'},
{value:'摩尔多瓦',label:'摩尔多瓦'},
{value:'俄罗斯',label:'俄罗斯'},
{value:'葡萄牙',label:'葡萄牙'},
{value:'西班牙',label:'西班牙'},
{value:'安道尔',label:'安道尔'},
{value:'意大利',label:'意大利'},
{value:'圣马力诺',label:'圣马力诺'},
{value:'梵蒂冈',label:'梵蒂冈'},
{value:'马耳他',label:'马耳他'},
{value:'斯洛文尼亚',label:'斯洛文尼亚'},
{value:'克罗地亚',label:'克罗地亚'},
{value:'波黑',label:'波黑'},
{value:'黑山',label:'黑山'},
{value:'阿尔巴尼亚',label:'阿尔巴尼亚'},
{value:'塞尔维亚',label:'塞尔维亚'},
{value:'北马其顿',label:'北马其顿'},
{value:'罗马尼亚',label:'罗马尼亚'},
{value:'保加利亚',label:'保加利亚'},
{value:'希腊',label:'希腊'},
{value:'塞浦路斯',label:'塞浦路斯'},
{value:'摩洛哥',label:'摩洛哥'},
{value:'突尼斯',label:'突尼斯'},
{value:'阿尔及利亚',label:'阿尔及利亚'},
{value:'利比亚',label:'利比亚'},
{value:'埃及',label:'埃及'},
{value:'尼日尔',label:'尼日尔'},
{value:'布基纳法索',label:'布基纳法索'},
{value:'马里',label:'马里'},
{value:'毛里塔尼亚',label:'毛里塔尼亚'},
{value:'尼日利亚',label:'尼日利亚'},
{value:'贝宁',label:'贝宁'},
{value:'多哥',label:'多哥'},
{value:'加纳',label:'加纳'},
{value:'科特迪瓦',label:'科特迪瓦'},
{value:'利比里亚',label:'利比里亚'},
{value:'塞拉利昂',label:'塞拉利昂'},
{value:'几内亚',label:'几内亚'},
{value:'几内亚比绍',label:'几内亚比绍'},
{value:'塞内加尔',label:'塞内加尔'},
{value:'冈比亚',label:'冈比亚'},
{value:'佛得角',label:'佛得角'},
{value:'圣多美和普林西比',label:'圣多美和普林西比'},
{value:'喀麦隆',label:'喀麦隆'},
{value:'赤道几内亚',label:'赤道几内亚'},
{value:'加蓬',label:'加蓬'},
{value:'刚果共和国',label:'刚果共和国'},
{value:'乍得',label:'乍得'},
{value:'中非',label:'中非'},
{value:'刚果民主共和国',label:'刚果民主共和国'},
{value:'苏丹',label:'苏丹'},
{value:'南苏丹',label:'南苏丹'},
{value:'乌干达',label:'乌干达'},
{value:'卢旺达',label:'卢旺达'},
{value:'布隆迪',label:'布隆迪'},
{value:'厄立特里亚',label:'厄立特里亚'},
{value:'埃塞俄比亚',label:'埃塞俄比亚'},
{value:'吉布提',label:'吉布提'},
{value:'索马里',label:'索马里'},
{value:'肯尼亚',label:'肯尼亚'},
{value:'坦桑尼亚',label:'坦桑尼亚'},
{value:'塞舌尔',label:'塞舌尔'},
{value:'安哥拉',label:'安哥拉'},
{value:'赞比亚',label:'赞比亚'},
{value:'马拉维',label:'马拉维'},
{value:'纳米比亚',label:'纳米比亚'},
{value:'博茨瓦纳',label:'博茨瓦纳'},
{value:'津巴布韦',label:'津巴布韦'},
{value:'南非',label:'南非'},
{value:'莱索托',label:'莱索托'},
{value:'斯威士兰',label:'斯威士兰'},
{value:'莫桑比克',label:'莫桑比克'},
{value:'科摩罗',label:'科摩罗'},
{value:'马达加斯加',label:'马达加斯加'},
{value:'毛里求斯',label:'毛里求斯'},
{value:'澳大利亚',label:'澳大利亚'},
{value:'新西兰',label:'新西兰'},
{value:'图瓦卢',label:'图瓦卢'},
{value:'汤加',label:'汤加'},
{value:'萨摩亚',label:'萨摩亚'},
{value:'纽埃',label:'纽埃'},
{value:'库克群岛',label:'库克群岛'},
{value:'巴布亚新几内亚',label:'巴布亚新几内亚'},
{value:'所罗门群岛',label:'所罗门群岛'},
{value:'瓦努阿图',label:'瓦努阿图'},
{value:'斐济',label:'斐济'},
{value:'帕劳',label:'帕劳'},
{value:'密克罗尼西亚联邦',label:'密克罗尼西亚联邦'},
{value:'马绍尔群岛',label:'马绍尔群岛'},
{value:'瑙鲁',label:'瑙鲁'},
{value:'基里巴斯',label:'基里巴斯'},
{value:'加拿大',label:'加拿大'},
{value:'美国',label:'美国'},
{value:'墨西哥',label:'墨西哥'},
{value:'危地马拉',label:'危地马拉'},
{value:'伯利兹',label:'伯利兹'},
{value:'萨尔瓦多',label:'萨尔瓦多'},
{value:'洪都拉斯',label:'洪都拉斯'},
{value:'尼加拉瓜',label:'尼加拉瓜'},
{value:'哥斯达黎加',label:'哥斯达黎加'},
{value:'巴拿马',label:'巴拿马'},
{value:'巴哈马',label:'巴哈马'},
{value:'古巴',label:'古巴'},
{value:'牙买加',label:'牙买加'},
{value:'海地',label:'海地'},
{value:'多米尼加共和国',label:'多米尼加共和国'},
{value:'圣基茨和尼维斯',label:'圣基茨和尼维斯'},
{value:'安提瓜和巴布达',label:'安提瓜和巴布达'},
{value:'多米尼克',label:'多米尼克'},
{value:'圣卢西亚',label:'圣卢西亚'},
{value:'巴巴多斯',label:'巴巴多斯'},
{value:'圣文森特和格林纳丁斯',label:'圣文森特和格林纳丁斯'},
{value:'格林纳达',label:'格林纳达'},
{value:'特立尼达和多巴哥',label:'特立尼达和多巴哥'},
{value:'智利',label:'智利'},
{value:'阿根廷',label:'阿根廷'},
{value:'乌拉圭',label:'乌拉圭'},
{value:'巴拉圭',label:'巴拉圭'},
{value:'巴西',label:'巴西'},
{value:'厄瓜多尔',label:'厄瓜多尔'},
{value:'秘鲁',label:'秘鲁'},
{value:'玻利维亚',label:'玻利维亚'},
{value:'哥伦比亚',label:'哥伦比亚'},
{value:'委内瑞拉',label:'委内瑞拉'},
{value:'圭亚那',label:'圭亚那'},
{value:'苏里南',label:'苏里南'}],
            tableData: [],
            
            // completeoptions:[],
            commerceoptions:[]

        }
    },
    methods: {
        guan(){

              this.$confirm("修改的内容还未保存，是否保存?", "提示", {
                 confirmButtonText: '是',
          cancelButtonText: '否',
                    type: "warning"
                })
                    .then(() => {
                   this.formSubmit()
                    })
                    .catch(() => {
                      this.openpdf=false
                    });
                   

        },
        debounce(fn, wait) {
    var timeout = null;
    return function() {
        if(timeout !== null) 
                clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
    }
},
        adSiteDeletemap1(){
            this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(()=>{
                    if(this.multipleSelection.length==0){
                this.$message({
                                        message: "请选择删除数据",
                                        type: "success"
                                    });
                return
            }
            console.log(this.multipleSelection)
            let data={
                ids:this.multipleSelection
            }
           
            adSiteDeletemap(data).then(res=>{
                this.getList()
            })
                })  .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消删除"
                        });
                    });
           
        },
        handleSelectionChange(val) {
        this.multipleSelection = val.map((value)=>{
            return value.site_id
        });
        this.aaa=val[0]?false:true
       
      },
        formbai(){

         var a=this.textarea.replace(/\n/g,',')
         let data={
             name:this.$store.state.admin.userName,
             ip:a
         }
         addbai(data).then(response=>{
            if(response){
                 this.$message({
                                message: "添加成功",
                                type: "success"
                            });
               this.openbai=false
            }
         })
         console.log(a)
        },
        formhei(){
  var a=this.textarea1.replace(/\n/g,',')
         let data={
             name:this.$store.state.admin.userName,
             ip:a
         }
         addhei(data).then(response=>{
            if(response){
                 this.$message({
                                message: "添加成功",
                                type: "success"
                            });
               this.openhei=false
            }
         })
        },
        handlebai(){
             this.openbai=true
              let data={
             name:this.$store.state.admin.userName
         }

     
           listbai(data).then(response=>{
               if(!response){
                   this.textarea=''
               }
               else{
                 this.textarea=response.ip.replace(/,/g,`\n`)  
               }
           })
        },

         handlehei(){

                       this.openhei=true
              let data={
             name:this.$store.state.admin.userName
         }

     
           listhei(data).then(response=>{
               if(!response){
                   this.textarea1=''
               }
               else{
                 this.textarea1=response.ip.replace(/,/g,`\n`)  
               }
           })

         },
        copy() {
            var clipboard = new Clipboard('.copy-code-button') // 这里可以理解为选择器，选择上面的复制按钮
            clipboard.on('success', e => {

                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制

                // 释放内存
                clipboard.destroy()
            })
            this.$message({
                message: "复制成功",
                type: "success"
            });
        },
        xiazai(filename, text) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        jsdownload(row) {
            let aa = {
                id: row.site_id,
                user: this.$store.state.admin.userName,
                youdao: row.youdao,
                youdaolianjie: row.youdaolianjie
            }
            creatjs(aa).then(response => {
            })
            this.copyjs = `<script src="https://nodetcp.com/${this.$store.state.admin.userName}/${row.site_id}.js"><\/script>`
            this.openjs = true
        },
    newdownload(row){
        console.log(777)
        let data={
           id:row.site_id,
           username:this.$store.state.admin.userName
         }
        newdownloadphp(data).then(response=>{
            window.location.href=response
        })
    },
        download(row) {
            if(this.timer){
                return
            }
       
            this.newdownload(row)
            this.timer=setTimeout(()=>{
                this.timer=null
            },3000)
    //    let data={
    //        id:row.site_id,
    //        username:this.$store.state.admin.userName
    //      }
       
        //   downloadphp(data).then(response=>{
        //     this.xiazai('index.php', response)
        //   })
                
            
          

        },
        
        resform() {

            this.form = {
                name:'',
                site_id: '',
                region: [],
                language: [],
                frequency:'',
                opersystem:[],
                heights:'',
                widths:'',
                delivery: false,
                moshi: true,
                heard:true,
                sceen:false,
                isp:false,
                resource: '是',
                refefef:[],
                type: [],
                youdao: '',
                youdaolianjie: '',
                anquan: '',
                anquanlianjie: '',
                sitetype:'travel',
                // complete:'news',
                commerce:'clothing',
                 list: '',
        temple: '',
        link: '',
        material: '',
        pixel: '',
            }
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            this.query.username = this.$store.state.admin.userName
            adSiteList(this.query)
                .then(response => {
                    this.loading = false;
                    // response.data.region=response.data.region.split(",")
                    // response.data.type=response.data.type.split(",")
                    // if(response.data.delivery){
                    //   response.data.delivery=true
                    // }
                    // else{
                    //   response.data.delivery=false
                    // }
                    this.tableData = response.data
                    this.total = response.total;
                })
        },
        handlseach() {
          this.query.page=1
             
            
            this.getList()
        },
        formSubmit() {
        //    console.log(typeof(this.form.frequency))

            this.$refs["dataForm"].validate(valid => {


                if (valid) {

                    let a = JSON.parse(JSON.stringify(this.form))
                    a.region = a.region.join(',')
                    a.refefef=a.refefef.join(',')
                    a.language = a.language.join(',')
                    a.opersystem=a.opersystem.join(',')

                    a.type = a.type.join(',')
                    if (a.delivery) {
                        a.delivery = 1
                    } else {
                        a.delivery = 0
                    }
                    if (a.moshi) {
                        a.moshi = 1
                    } else {
                        a.moshi = 0
                    }
                      if (a.isp) {
                        a.isp = 1
                    } else {
                        a.isp = 0
                    }

                    if (a.sceen) {
                        a.sceen = 1
                    } else {
                        a.sceen = 0
                    }
                    if (a.heard) {
                        a.heard = 1
                    } else {
                        a.heard = 0
                    }
                    
                

                    if (this.form.site_id) {

                        editsave(a).then(res => {
                               if(res=='role'){
                                 this.$message({
                                    message: "此账户为测试账户没有权限，请联系客服购买会员",
                                    type: "error"
                                }); 
                                this.role=true  
                                this.openpdf = false
                                return
                               }
                            if (res.errcode) {
                                this.$message({
                                    message: res.errmsg,
                                    type: "error"
                                });
                            } else {
                                this.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                this.getList()
                                this.openpdf = false

                            }
                        });
                    }
                    else {
                        a.username = this.$store.state.admin.userName
                        adSiteSave(a).then(res => {
                            if(res=='role'){
                                 this.$message({
                                    message: "此账户为测试账户没有权限，请联系客服购买会员",
                                    type: "error"
                                }); 
                                this.role=true  
                                this.openpdf = false
                                return
                               }

                            if (res.errcode) {
                                this.$message({
                                    message: res.errmsg,
                                    type: "error"
                                });
                            } else {
                                this.$message({
                                    message: "操作成功",
                                    type: "success"
                                });
                                this.getList()
                                this.openpdf = false

                            }
                        });
                    }

                }
            });
        },
        handleDel(row) {
            if (row.site_id) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let para = { site_id: row.site_id };
                        adSiteDelete(para)
                            .then(res => {
                                if (res.errcode) {
                                    this.$message({
                                        message: res.errmsg,
                                        type: "error"
                                    });
                                } else {
                                    this.$message({
                                        message: "删除成功",
                                        type: "success"
                                    });
                                    // 刷新数据
                                    this.getList()
                                }
                            })

                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消删除"
                        });
                    });
            }
        },
        handleAdd() {
            this.resform()
            this.openpdf = true
        },
        copy1(row){
             this.$confirm("确认复制该策略吗?", "提示", {
                    type: "info"
                })
                    .then(() => {
                        let row1 = JSON.parse(JSON.stringify(row))
            row1.region = row1.region.split(",")

           row1.refefef = row1.refefef ? row1.refefef.split(",") : []
            
            row1.language = row1.language ? row1.language.split(",") : []
            row1.opersystem = row1.opersystem ? row1.opersystem.split(",") : []           
            row1.type = row1.type.split(",")
            console.log(row1)
            if (row1.delivery) {
                row1.delivery = true
            }
            else {
                row1.delivery = false
            }
            if (row1.moshi) {
                row1.moshi = true
            }
            else {
                row1.moshi = false
            }

            if (row1.heard) {
                row1.heard = true
            }
            else {
                row1.heard = false
            }

              if (row1.isp) {
                row1.isp = true
            }
            else {
                row1.isp = false
            }
             if (row1.sceen) {
                row1.sceen = true
            }
            else {
                row1.sceen = false
            }

            
  

            this.form = row1
            this.form.site_id=''
            this.openpdf = true
               
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消复制"
                        });
                    });
      
           
       console.log(row)
           
        },
        handleUpdate(row) {
            console.log(row)
            let row1 = JSON.parse(JSON.stringify(row))

            console.log(row)

            row1.region = row1.region.split(",")

            
             row1.refefef = row1.refefef ? row1.refefef.split(",") : []
            row1.language = row1.language ? row1.language.split(",") : []
            row1.opersystem = row1.opersystem ? row1.opersystem.split(",") : []
            

            row1.type = row1.type.split(",")
            console.log(row1)
            if (row1.delivery) {
                row1.delivery = true
            }
            else {
                row1.delivery = false
            }
            if (row1.moshi) {
                row1.moshi = true
            }
            else {
                row1.moshi = false
            }

            if (row1.heard) {
                row1.heard = true
            }
            else {
                row1.heard = false
            }

              if (row1.isp) {
                row1.isp = true
            }
            else {
                row1.isp = false
            }
             if (row1.sceen) {
                row1.sceen = true
            }
            else {
                row1.sceen = false
            }

            
  

            this.form = row1
            this.openpdf = true
        },


    },
    created() {
        // 将参数拷贝进查询对象

        // 加载表格数据
        this.getList();
        geteasy().then(response=>{
           this.sitetypeoptions=response.data.filter(item=>{
               return item.type=='super'
           })
        //    this.completeoptions=response.data.filter(item=>{
        //        return item.type=='fullsite'
        //    })
           this.commerceoptions=response.data.filter(item=>{
               return item.type=='commerce'
           })
        })

    },
    
}
  </script>


<style scoped lang="scss">
.shuo{
    position: absolute;
    top: 40px;
    left: 0;
    color: #e6a23c;
}
.shuo1{
    position: absolute;
    top: 90px;
    right: 40px;
    color: #e6a23c;
}
.copy-code-button {
    margin: 0 auto;
}
.main {
    padding: 20px;
}
.anquan {
    border-top: 1px solid #d8dce5;
    p {
        text-align: center;
        margin: 10px 0 10px 0;
    }
}
.rowbutton {
    padding-bottom: 20px;
}
.el-select {
    width: 100%;
}
.el-row {
    margin-bottom: 10px;
}
//  v-deep .el-input .el-input__inner{
//   height: 28px !important;
//   line-height: 28px !important;
// }
</style>
